import React from 'react';
import {useParams} from "react-router-dom";
import NecessaryDocumentCard from "./components/necessaryDocumentCard";
import WorkProcedureCard from "./components/workProcedureCard";
import TimeOfSettlementCard from "./components/timeOfSettlementCard";
import ApplicationCard from "./components/applicationCard";
import "../../assets/css/pages/services/details.scss";
import useService from "../../hooks/public/useService";

const Details = () => {
    const {id} = useParams();
    const {data} = useService(id);
    const {name, necessaryDoc, workProcedure, settlementTime, applicationFee} = data;

    return (
        <section className='service__details-section'>
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>{data && name} Details</h1>
                    <div className="content-body">
                        {
                            data &&
                            <>
                                <NecessaryDocumentCard necessaryDoc={necessaryDoc}/>
                                <WorkProcedureCard workProcedure={workProcedure}/>
                                <TimeOfSettlementCard settlementTime={settlementTime}/>
                                <ApplicationCard applicationFee={applicationFee}/>
                                {/*<CommentCard/>*/}
                            </>
                        }

                    </div>
                </div>
            </div>
        </section>
    );
};

export default Details;
